// extracted by mini-css-extract-plugin
export default {"size":"40px","ingredientContainer":"G3fe242","ingredientImage":"G4c6a91","ingredientLabel":"G9a93d2"};